import { render, staticRenderFns } from "./SetMaxCapitalWidget.vue?vue&type=template&id=58cc6f26&"
import script from "./SetMaxCapitalWidget.vue?vue&type=script&lang=js&"
export * from "./SetMaxCapitalWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports